import { status } from "skin/event/status";

const loyaltyPromo = (obj, ms, story, data, d, action) => {
	// const start = data.s.values.fld["type.start"];
	// const end = data.s.values.fld["type.end"];
	// console.log(111, obj)
	// if (obj.action === "loadData" && start) data.setValue("type.start", toLocaltime(start));
	// if (obj.action === "loadData" && end) data.setValue("type.end", toLocaltime(end));
	return status.action;
};

export default loyaltyPromo;

// function toLocaltime(t) {
// 	const [h, m] = t.split(":");
// 	const date = new Date();
// 	date.setUTCHours(h, m, 0, 0);
// 	return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
// }
